var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"bg_white",domProps:{"innerHTML":_vm._s(_vm.html)}}):_c('div',{staticClass:"bg_white pt16 pb16 pl16 pr16 ab"},[_vm._v("アクセスエラー"),_c('br'),_vm._v("coNPusアプリから再度開き直してください。")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-308d6411","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notification/Information.vue
// module id = null
// module chunks = 